import { Dictionary } from '@ngrx/entity/src/models';
import { IntelligenceModels } from '@models/intelligence.model';
import { crudActions, DatasetTableConfig, TableConfigBuilder, textColumn } from '@ui/lib/ui-kit/ui-dataset-table';

type TimeSchedule = IntelligenceModels.TimeSchedules.TimeSchedule;

export interface CreateTimeScheduleResultTableConfigDependencies {
  /** Ids whose own edit or delete request is in flight; their row icons go away. */
  busyIds: Dictionary<boolean>;
}

/**
 * Twin of the Database → Time schedule table: the same single "Schedule name"
 * column and the same edit / delete row icons, at the page's row height.
 *
 * A row mid-request hides both icons exactly as the page hides them while a
 * delete is in flight, so a second click cannot fire a duplicate write.
 *
 * Deliberately without a `defaultRowAction`: the page's row click-through to the
 * editor is left off here, matching the other Cmd+K panels, whose rows only act
 * through their icons.
 */
export function createTimeScheduleResultTableConfig(
  dependencies: CreateTimeScheduleResultTableConfigDependencies,
): DatasetTableConfig<TimeSchedule> {
  return new TableConfigBuilder<TimeSchedule>()
    .columns([
      textColumn<TimeSchedule>('name', 'SCHEDULE_LIST.TABLE.NAME', {
        width: 'minmax(200px, 1fr)',
        mobileVisible: true,
      }),
    ])
    .actions(
      crudActions<TimeSchedule>(
        { visible: (row) => !dependencies.busyIds[row._id] },
        { visible: (row) => !dependencies.busyIds[row._id] },
      ),
    )
    .trackBy('_id')
    .rowHeight(40)
    .build();
}
